import { Link } from "react-router-dom" ;
import React, { useState, useEffect } from 'react';

const Relaxation29 = () => {
  const initialTimer = 60;
  const [timer, setTimer] = useState(initialTimer); // Initial countdown time in seconds
  const [isPlaying, setIsPlaying] = useState(false);

  useEffect(() => {
    let interval;

    if (isPlaying && timer > 0) {
      interval = setInterval(() => {
        setTimer((prevTimer) => prevTimer - 1);
      }, 1000);
    }

    return () => {
      clearInterval(interval);
    };
  }, [isPlaying, timer]);

  const handlePlayClick = () => {
    setIsPlaying(true);
  };

  const handlePauseClick = () => {
    setIsPlaying(false);
  };

  const handleCancelClick = () => {
    setIsPlaying(false);
    setTimer(initialTimer);
  };

  return (
    <div>
      
       <section className="bg-[#fff] text-[#295700]">
  <div className="">
    <div className="">
      
    </div> {/*end nav*/}
    {/*Main section*/}
    <main className="px-6 py-6 bg-[#F5F5F5]  border mt-4 mb-4 col-span-2 mr-12 h-screen shadow-[0_3px_10px_rgb(0,0,0,0.2)] m-4 rounded-md">
      <div>
        <h1 className="text-[30px] font-bold">RELAXATION</h1>
        <div className="pt-4">
          <h2 className="text-[18px] font-semibold">1 MINUTE BREATHING EXERCISE</h2>
        </div>
      </div>
      <div className="mt-6 mb-6 flex flex-col items-center">
        <div className="w-96 flex flex-col justify-center items-center">
          <img src="https://res.cloudinary.com/dmvphwhvc/image/upload/v1701178884/kjfqtrzschlv23se3qzm.png" alt className="flex justify-center items-center" />
          {isPlaying && <p>{timer} seconds remaining</p>}
        </div>
        <div className="flex justify-center items-center mt-24 space-y-2">
         <Link to=''> <img onClick={handlePlayClick} src="https://res.cloudinary.com/dmvphwhvc/image/upload/v1701178679/ljnisdvkwrq0zixpk7jr.png" alt="Play" className="h-10" /></Link>
         <Link to=''><img onClick={handlePauseClick} src="https://res.cloudinary.com/dmvphwhvc/image/upload/v1701178679/pxsqwr0jy4y6vxacud4y.png" alt="Close" className="h-10" /></Link>
         <Link to='../relaxation5'>  <img onClick={handleCancelClick} src="https://res.cloudinary.com/dmvphwhvc/image/upload/v1701178884/aqhhjahhkpg9fegczzjy.png" alt="Home" className="h-8" /></Link>
        </div>
        <div className="mt-24 space-y-2">
          <button className="px-16 py-2 bg-[#295700] rounded text-[#fff] ml-8"><Link to="../relaxation9">COMPLETE</Link></button>
        </div>
      </div>
    </main>
  </div>
</section>

    </div>
  )
}

export default Relaxation29